import './form-item.scss';
import { useFormContext } from "react-hook-form";
import { ItemFormSchema } from "@factory/form/form.rule";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import InputTextareaControl from '@shared/ui/hook-form/input-textarea-control/input-textarea-control';

type InputFormSchema = ItemFormSchema;
export function FormItem() {
  const { control } = useFormContext<ItemFormSchema>();
  return (
    <div id="FormItem" className="item">
      <InputControl<InputFormSchema>
        control={control}
        name="name"
        label="Name"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter name"
      />
      <InputTextareaControl<InputFormSchema>
        control={control}
        name="description"
        label="Description"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter description"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="amount"
        label="Amount"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter amount"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="duration"
        label="Duration Minutes (Optional)"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter duration for time-based items only"
        hint='Enter duration for time-based items only'
      />
    </div>
  );
}

export default FormItem;